export default __webpack_public_path__ + "static/media/Dog4.2b7a8086.jpg";